/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RegistrantsToUpdate
 */
export interface RegistrantsToUpdate {
  /**
   * The unique identifier of the registrant.
   * @type number
   * @memberof RegistrantsToUpdate
   */
  registrantKey: number
  /**
   * The attending determines whether the registrant will attend.
   * @type boolean
   * @memberof RegistrantsToUpdate
   */
  attending: boolean
}

export function RegistrantsToUpdateFromJSON(json: any): RegistrantsToUpdate {
  return RegistrantsToUpdateFromJSONTyped(json, false)
}

export function RegistrantsToUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistrantsToUpdate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    registrantKey: json['registrantKey'],
    attending: json['attending'],
  }
}

export function RegistrantsToUpdateToJSON(
  value?: RegistrantsToUpdate | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    registrantKey: value.registrantKey,
    attending: value.attending,
  }
}
